import BookingForm from "../../../components/forms/BookingForm";
import { useForm } from "antd/lib/form/Form";
type props = {
  bookingId: number
};

export const DetailedBookingView = ({ bookingId }: props) => {
  const [form] = useForm();
  return <BookingForm bookingId={bookingId}></BookingForm>;
};
